import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type GlobalSettingsQueryVariables = {};


export type GlobalSettingsQuery = (
  { __typename?: 'Query' }
  & { globalSettings: Array<(
    { __typename: 'OptionsSetting' }
    & Pick<Types.OptionsSetting, 'options' | '_id' | 'type'>
  ) | (
    { __typename: 'ActiveProvingTypesSetting' }
    & Pick<Types.ActiveProvingTypesSetting, '_id' | 'type'>
    & { typeSettings: Array<(
      { __typename?: 'ProvingTypeSetting' }
      & Pick<Types.ProvingTypeSetting, 'type' | 'isActive'>
    )> }
  ) | (
    { __typename: 'SingleValueSetting' }
    & Pick<Types.SingleValueSetting, 'value' | '_id' | 'type'>
  ) | (
    { __typename: 'FileSetting' }
    & Pick<Types.FileSetting, '_id' | 'type'>
  ) | (
    { __typename: 'GlobalMessageSetting' }
    & Pick<Types.GlobalMessageSetting, '_id' | 'type'>
  )> }
);

export const GlobalSettingsDocument = gql`
    query GlobalSettings {
  globalSettings {
    _id
    __typename
    type
    ... on OptionsSetting {
      options
    }
    ... on ActiveProvingTypesSetting {
      typeSettings {
        type
        isActive
      }
    }
    ... on SingleValueSetting {
      value
    }
  }
}
    `;

    export function useGlobalSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlobalSettingsQuery, GlobalSettingsQueryVariables>) {
      return ApolloReactHooks.useQuery<GlobalSettingsQuery, GlobalSettingsQueryVariables>(GlobalSettingsDocument, baseOptions);
    };
      export function useGlobalSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalSettingsQuery, GlobalSettingsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<GlobalSettingsQuery, GlobalSettingsQueryVariables>(GlobalSettingsDocument, baseOptions);
      };
      
export type GlobalSettingsQueryHookResult = ReturnType<typeof useGlobalSettingsQuery>;
export type GlobalSettingsQueryResult = ApolloReactCommon.QueryResult<GlobalSettingsQuery, GlobalSettingsQueryVariables>;